var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadowPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 48C14.9313 47.9999 1.2698e-06 19 1.2698e-06 19L55 19C55 19 40.0687 48.0001 27.5 48Z",
    fill: "#CBC1FF",
    fillOpacity: 0.52
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6352 37.3523C16.3917 37.3522 4.22255 2.66588e-05 4.22255 2.66588e-05L49.0478 2.28882e-05C49.0478 2.28882e-05 36.8787 37.3524 26.6352 37.3523Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowPolygon);
export default __webpack_public_path__ + "static/media/shadowPolygon.ab406ccecd15a517c74f6d6af98ed84e.svg";
export { ForwardRef as ReactComponent };